import React from 'react';

import {
  DossierResponseDto,
  EntreeVehiculeViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import { FormInputProps } from 'components/BaseForm/types';

import { EntreVehiculeFormValues } from './types';
import { generateEntreeVehiculeFromDossier } from './utils';

interface WithoutJusticeEntreeVehiculeFormProps {
  close: () => void;
  dossier: DossierResponseDto;
  inProgress: boolean;
  validateField: (
    field: EntreeVehiculeViolationDtoFormFieldEnum,
    formValues: EntreVehiculeFormValues,
  ) => Promise<void>;
  submit: (values: EntreVehiculeFormValues) => void;
  baseInputs: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  >[];
  autoriteFourriereSelectInput: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  >;
}

const WithoutJusticeEntreeVehiculeForm = ({
  close,
  dossier,
  inProgress,
  validateField,
  submit,
  baseInputs,
  autoriteFourriereSelectInput,
}: WithoutJusticeEntreeVehiculeFormProps) => {
  const inputs: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  >[] = [...[autoriteFourriereSelectInput], ...baseInputs];

  return (
    <BaseForm
      initialValues={generateEntreeVehiculeFromDossier(dossier)}
      isSubmitting={inProgress}
      validateField={validateField}
      onSubmit={submit}
      onCancel={close}
      inputs={inputs}
    />
  );
};

export default WithoutJusticeEntreeVehiculeForm;
